<template>
  <vue-recaptcha :sitekey="sitekey" :loadRecaptchaScript="true" @verify="validate" />
</template>
<script>
import { VueRecaptcha } from 'vue-recaptcha';
export default {
  name: 'Recaptcha',
  components: { VueRecaptcha },
  data() {
    return {
      sitekey: process.env.VUE_APP_RECAPTCHA_PUBLIC_KEY,
    };
  },
  methods: {
    validate(response) {
      this.$emit('validate', response);
    },
  },
};
</script>
